import { render, staticRenderFns } from "./CartTabDetails.vue?vue&type=template&id=0855fe62&scoped=true"
import script from "./CartTabDetails.vue?vue&type=script&lang=ts"
export * from "./CartTabDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0855fe62",
  null
  
)

export default component.exports